import React from 'react';
import _ from 'lodash';
import ComboBox from '../../../components/ComboBox/ComboBox';
import EnvironmentItem from '../../../components/EnvironmentItem/EnvironmentItem';
import HeaderPartSeparator from '../../../headers/HeaderPartSeparator/HeaderPartSeparator';
import servers from '../../../../const/servers';
import canChangeEnvironment from '../../../../services/mini/canChangeEnvironment';

class AlanyticsHeaderPart extends React.Component {

    onChangeAlanyticsRange = (rangeItem) => {
        this.props.onChangeAlanyticsRange(rangeItem.key);
    }

    onRefreshClick = () => {
        if (window.alanThrottleAnalyticsIsDisabled) {
            this.refreshAlanyticsDataWithoutThrotling();
        } else {
            this.refreshAlanyticsData();
        }
    }

    refreshAlanyticsData = _.throttle(() => {
        console.info('refreshAlanyticsData with throttle');
        this.props.refreshAlanyticsData();
    }, 3000);

    refreshAlanyticsDataWithoutThrotling = () => {
        console.info('refreshAlanyticsData WITHOUT throttle');
        this.props.refreshAlanyticsData();
    }

    changeEnvironment = (environmentObj) => {
        const environment = environmentObj.key;
        const { project, changeEnvironment, tier } = this.props;

        if (canChangeEnvironment(tier, environment)) {
            changeEnvironment({project, environment});
        }
    }

    render() {
        const {
            environment,
            project,
        } = this.props;

        return (
            <div className="analytics-header">
                <HeaderPartSeparator height={32} />
                <div className="page-sub-name">Analytics</div>
                <HeaderPartSeparator height={32} />
                <ComboBox values={servers}
                    valueKey="key"
                    valueName="name"
                    width="142px"
                    classes={environment}
                    environmentItem={true}
                    selectedValueId={environment}
                    onValueSelect={this.changeEnvironment}
                    tooltipMsg="Switch between Development, Testing,<br/>and Production environments"
                    tooltipId="environmentCbTooltip"
                    renderItem={(serverItem) => {
                        return <EnvironmentItem
                            serverItem={serverItem}
                            project={project} />;
                    }} />
                <div className="action-btn light-blue-with-border analytics-header_refresh-btn"
                    onClick={this.onRefreshClick}><i className="icon icon-alan-refresh" />Refresh Data</div>
            </div>
        );
    }
}

export default AlanyticsHeaderPart;
